export enum CampaignsScreenUrlSearchQueryParams {
    campaignsIds = 'campaigns-ids',
    ulogin = 'ulogin'
}

export enum SurveyStatus {
    DRAFT = 'DRAFT',
    MODERATION = 'MODERATION',
    MODERATION_REJECTED = 'MODERATION_REJECTED',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    UNFEASIBLE = 'UNFEASIBLE'
}

export enum BrandSurveyStopReason {
    LOW_BUDGET = 'LOW_BUDGET',
    LOW_REACH = 'LOW_REACH'
}

export interface BrandSurveyStatus {
    surveyStatus: SurveyStatus;
    reasonIds: string[];
    brandSurveyStopReasons: BrandSurveyStopReason[];
}
